import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NETWORK } from '@arianee/arianeejs';
import { IonTabs, Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from 'src/app/providers/user-service/user.service';

import { ArianeeService } from '../../../providers/arianee-service/arianee.service';
import { EventLoggerService } from '../../../providers/event-logger/event-logger-service';
import { FeatureFlipService } from '../../../providers/feature-flip-service/feature-flip.service';
import { NavigationService } from '../../../providers/navigation-service/navigation-service';
import { NotificationService } from '../../../providers/notification-service/notification.service';
import { TabsService } from '../../../providers/tabs/tabs.service';

@Component({
	selector: 'app-tab',
	templateUrl: './tab.page.html',
	styleUrls: ['./tab.page.scss'],
})
export class TabPage {
	@ViewChild(IonTabs, { static: true }) tabs!: IonTabs;
	hideTabs = false;
	subscriptions: Subscription[] = [];
	selectedTab!: string;

	public isTestNetMode = false;
	public network: NETWORK;

	constructor(
		public notificationService: NotificationService,
		public featureFlipService: FeatureFlipService,
		private eventLogger: EventLoggerService,
		private tabsService: TabsService,
		private userService: UserService,
		private platform: Platform,
		private activatedRoute: ActivatedRoute,
		private navigationService: NavigationService,
		private arianeeService: ArianeeService,
	) {
		this.subscriptions.push(
			this.tabsService.hideTabsMenu.subscribe((data: boolean) => {
				this.hideTabs = data;
			}),
		);
	}

	ngOnInit() {
		this.platform.ready().then(() => {
			const sub = this.arianeeService.$walletInitialize.subscribe((network) => {
				this.isTestNetMode = network !== NETWORK.mainnet;
				this.network = network;
			});
			this.subscriptions.push(sub);
		});

		this.updateSelectedTabAfterRedirection();
	}

	/**
	 * Focus selected Tab after url redirection
	 */
	updateSelectedTabAfterRedirection() {
		this.navigationService.currentRoute.subscribe((route: string) => {
			const routeSplit: string[] = route.split('/');
			this.selectedTab =
				routeSplit.length > 0
					? route.split('/').filter((val: string) => !!val)[1]
					: 'brand-list';
		});
	}

	onTabChange(evt) {
		this.eventLogger.logEvent('tabChange', { tab: evt.tab });
		this.navigationService.currentRoute.subscribe(async (route: string) => {
			this.hideTabs = await this.hideTabBar(evt, route);
		});
	}

	async hideTabBar(evt, route) {
		const isNewProductDetail = await this.featureFlipService
			.$isFeatureFlipOnce('newProductDetail')
			.toPromise();
		if (isNewProductDetail) {
			return (
				evt.tab === 'scan-full-page' ||
				route.includes('product-detail') ||
				route.includes('poap-detail') ||
				route.includes('pending')
			);
		}
		return evt.tab === 'scan-full-page';
	}

	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}

	get $getUnreadNotifications() {
		return this.notificationService
			.$getUnreadNotification()
			.pipe(map((notif) => notif.length));
	}
}
